import { useEffect } from 'react';

/**
 * Elements that should get desktop-like hover feedback on touch / mobile.
 * Phones (and Chrome device mode) often have no real :hover — we use .is-touch-hover.
 */
const HOVERABLE =
  [
    '.about-meet-team-card',
    '.about-why-card',
    '.about-why-intro-card',
    '.about-team-works-card',
    '.about-founder-card',
    '.about-founder-stat',
    '.about-founder-quote-box',
    '.about-founder-photo-card',
    '.about-founder-photo-frame',
    '.about-split-copy',
    '.about-split-media',
    '.about-exp-visual',
    '.about-exp-copy',
    '.about-exp-heading-block',
    '.about-value-copy',
    '.about-value-visual',
    '.about-collage-img',
    '.contact-info-card',
    '.contact-form-panel',
    '.contact-map-wrap',
    '.privacy-trust-card',
    '.terms-trust-card',
    '.terms-agreement-callout',
    '.privacy-acc-item',
    '.terms-acc-item',
    '.privacy-overview',
    '.terms-overview',
    '.legal-closing-card',
    '.services-vas-card',
    '.services-vas-flip',
    '.process-roadmap-card',
    '.home-trust-card',
    '.home-service-tile',
    '.home-stat',
    '.home-process-step',
    '.uc-card',
    '.tilt-card',
    '.nav-link',
    '.nav-contact-btn',
    '.footer-link',
    '.home-hero-cta',
    '.home-cta-primary',
    '.home-service-primary',
  ].join(',');

function clearTouchHover(except) {
  document.querySelectorAll('.is-touch-hover').forEach((node) => {
    if (node !== except) node.classList.remove('is-touch-hover');
  });
}

function shouldSimulateHover(event) {
  // Real desktop mouse with fine pointer → CSS :hover is enough
  const fineDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fineDesktop && event.pointerType === 'mouse' && window.innerWidth > 720) {
    return false;
  }
  return true;
}

/**
 * Tap/click applies .is-touch-hover so zoom/lift works on phones and mobile emulators.
 */
export default function TouchHover() {
  useEffect(() => {
    document.documentElement.classList.add('has-touch-hover');

    const onPointerDown = (event) => {
      if (!shouldSimulateHover(event)) return;

      const target = event.target instanceof Element ? event.target.closest(HOVERABLE) : null;
      clearTouchHover(target);
      if (target) {
        target.classList.add('is-touch-hover');
        // Also mark photo frame when tapping the card wrapper / image
        const frame = target.classList.contains('about-founder-photo-frame')
          ? target
          : target.querySelector?.('.about-founder-photo-frame');
        if (frame && frame !== target) frame.classList.add('is-touch-hover');
      }
    };

    document.addEventListener('pointerdown', onPointerDown, { passive: true });

    return () => {
      document.documentElement.classList.remove('has-touch-hover');
      clearTouchHover(null);
      document.removeEventListener('pointerdown', onPointerDown);
    };
  }, []);

  return null;
}
